import { __extends } from "tslib";
import React from 'react';
import * as ReactDOM from 'react-dom';
var EmoteSelectorPortal = /** @class */ (function (_super) {
    __extends(EmoteSelectorPortal, _super);
    function EmoteSelectorPortal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmoteSelectorPortal.prototype.componentDidMount = function () {
        this.container = document.getElementById('emote-selector-portal');
        if (!this.container) {
            var el = document.createElement('div');
            el.id = 'emote-selector-portal';
            document.body.appendChild(el);
        }
    };
    EmoteSelectorPortal.prototype.render = function () {
        if (!document.getElementById('emote-selector-portal')) {
            return null;
        }
        return ReactDOM.createPortal(this.props.children, document.getElementById('emote-selector-portal'));
    };
    return EmoteSelectorPortal;
}(React.Component));
export { EmoteSelectorPortal };
//# sourceMappingURL=Portal.js.map